import React, { Fragment, ReactNode, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop({ children }: { children: ReactNode }) {
  const location = useLocation();
  useLayoutEffect(() => {
    document.getElementsByTagName("body")[0].scrollTop = 0;
  }, [location.pathname]);
  return <Fragment>{children}</Fragment>;
}

export { ScrollToTop };
